import { render, staticRenderFns } from "./CheckboxSelectYwyForm.vue?vue&type=template&id=12f6cfc2"
import script from "./CheckboxSelectYwyForm.vue?vue&type=script&lang=js"
export * from "./CheckboxSelectYwyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports